@if (data) {
  @let index = (selectedIndex | async) || 0;
  <div class="selector">
    <button (click)="previous()">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <span>{{ index + 1 }} / {{ data.length }}</span>
    <button (click)="next()">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
  @if (fields && (fields.get(0)!.fields.get(0)!.value | async) !== null) {
    <app-form [fields]="fields" [options]="options" />
  }
}
